import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import times from 'lodash/times';
import constant from 'lodash/constant';
import map from 'lodash/map';
import { getCurrentBoats as bts } from '../../../utils/language';
import MiniListing from '../../../components/MiniListing';
import LoadingMiniListing from '../../../components/MiniListing/LoadingMiniListing';
import { addLead } from '../../../store/actions/dataLayer';
import { getConfig } from '../../../config/portal';
import { PortalConfigContext } from '../../../config/portal';

import './styles.css';

class SimilarListings extends PureComponent {
  renderMiniListings() {
    const currentLocale = this.props.intl.locale;
    const currencyCode = get(
      getConfig(),
      `languages.${currentLocale}.currency.abbr`,
      null
    );
    const customPricingOptions = {
      currency: get(
        getConfig(),
        `supportedCurrencies.${currencyCode}`,
        undefined
      ),
      formatingOptions: get(
        getConfig(),
        `languages.${currentLocale}.currency.format`,
        undefined
      )
    };

    let { similarListings } = this.props;
    return map(similarListings, (listing) => {
      return (
        <MiniListing
          key={listing.id}
          listing={listing}
          href={listing.href}
          listingType={bts().LISTING_SIMILAR_LISTING}
          customPricingOptions={customPricingOptions}
        />
      );
    });
  }

  renderLoading() {
    let list = times(6, constant(null));
    return map(list, (listing, index) => {
      return <LoadingMiniListing key={index} />;
    });
  }

  render() {
    const { similarListings, isLoading } = this.props;

    return (
      similarListings.length > 0 && (
        <div id="similar-boats-section" className="similar-boats">
          <ul>
            {isLoading ? this.renderLoading() : this.renderMiniListings()}
          </ul>
        </div>
      )
    );
  }
}

SimilarListings.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    owner: PropTypes.shape({
      name: PropTypes.string
    }),
    isOemModel: PropTypes.bool
  }),
  listingId: PropTypes.number,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired
  }).isRequired,
  isLoading: PropTypes.bool,
  addLead: PropTypes.func.isRequired,
  similarListings: PropTypes.array
};

SimilarListings.contextType = PortalConfigContext;

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      addLead
    },
    dispatch
  )
)(injectIntl(SimilarListings));
